<onyx-modal
  variant="center"
  [heading]="`${I18N}.heading`"
  [size]="isDouble ? 980 : 480"
  [close$]="close$"
  [loading]="telematicsStore.loading()"
  (closeModal)="dialogRef.close()"
>
  <div class="container" [class.double]="isDouble">
    @for (vehicleSet of vehicleSets; track vehicleSet.vehicle.uuid) {
      @if (!$first) {
        <div class="separator"></div>
      }

      <app-swap-status-form-set
        [swapUuid]="data.swapUuid"
        [vehicleSet]="vehicleSet"
        [showHeading]="isDouble"
      ></app-swap-status-form-set>
    }
  </div>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button
      color="black"
      [disabled]="isDisabled()"
      [spinner]="loading()"
      [onyxTooltip]="tooltip()"
      (click)="submit()"
    >
      {{ 'labels.save' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
